import { render, staticRenderFns } from "./CheckPhoto.vue?vue&type=template&id=88ffc2be&scoped=true&"
import script from "./CheckPhoto.vue?vue&type=script&lang=js&"
export * from "./CheckPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ffc2be",
  null
  
)

export default component.exports